// extracted by mini-css-extract-plugin
export default {"ProfileWrap":"user-profile-action_ProfileWrap__0Alh1","LogoutText":"user-profile-action_LogoutText__I1b9P"};